import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/notification/main"));

const Notification = () => {
  return (
    <Layout pageHeading="Notification">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default Notification;